var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { MUSEUMS_REQUESTED, MUSEUMS_RECEIVED, MUSEUMS_FAILED } from './museums-action';

var initialState = {
    isFetching: false,
    items: {},
    allIds: [],
    fetchFailed: false,
    list: []
};

var museumsReducer = function museumsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case MUSEUMS_REQUESTED:
            return _extends({}, state, {
                isFetching: true
            });
        case MUSEUMS_RECEIVED:
            return _extends({}, state, {
                isFetching: false,
                fetchFailed: false,
                items: action.museums,
                allIds: action.allIds,
                list: action.museumsList
            });
        case MUSEUMS_FAILED:
            return _extends({}, state, {
                isFetching: false,
                fetchFailed: true
            });
        default:
            return state;
    }
};

export default museumsReducer;